// extracted by mini-css-extract-plugin
export default {"wrapper":"tile_button-module___wrapper___d0c8ee65","content":"tile_button-module___content___b4252f12"};